var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"20px 0"}},[_c('v-skeleton-loader',{attrs:{"type":"article, actions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }